/**
 * Status do canal WhatsApp Não Oficial .
 * Reutiliza o pattern existente: GetAccounts → filtra por agent_flow_id.
 */

import { useState, useEffect, useCallback, useRef } from 'react';
import { GetAccounts } from '../../../../../services/WaBottyServices';

const STATUS_VARIANT_MAP = {
  WORKING: 'success',
  STARTING: 'info',
  SCAN_QR_CODE: 'warning',
  STOPPED: 'neutral',
  FAILED: 'danger',
};

const STATUS_LABEL = {
  WORKING: 'Conectado',
  STARTING: 'Iniciando',
  SCAN_QR_CODE: 'Aguardando QR Code',
  STOPPED: 'Parado',
  FAILED: 'Falha na conexão',
};

export default function useWahaStatus(agentId) {
  const [session, setSession] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const cancelRef = useRef({ cancelled: false });

  const fetch = useCallback(async () => {
    if (!agentId || agentId === 'novo') {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const data = await GetAccounts();
      if (cancelRef.current.cancelled) return;
      const list = Array.isArray(data) ? data : data?.sessions || [];
      // Filtra: WAHA only + linked to this agent_flow
      const matched = list.find(
        (s) => s?.provider !== 'cloud_api' && String(s?.agent_flow_id) === String(agentId),
      );
      setSession(matched || null);
    } catch (err) {
      if (cancelRef.current.cancelled) return;
      setError(err.message);
      setSession(null);
    } finally {
      if (!cancelRef.current.cancelled) setIsLoading(false);
    }
  }, [agentId]);

  useEffect(() => {
    cancelRef.current = { cancelled: false };
    fetch();
    return () => {
      cancelRef.current.cancelled = true;
    };
  }, [fetch]);

  const isConnected = session?.status === 'WORKING';
  const statusKey = session?.status || '';

  const phone =
    session?.me?.id?.split('@')[0] ||
    session?.phone ||
    session?.name ||
    '';

  // Backend retorna agent_paused=true quando o agente está pausado mas a
  // sessão continua WORKING (Central de Atendimento recebe normalmente).
  const agentPaused = !!session?.agent_paused;

  // Label/variant ajustados quando pausado: a sessão pode estar WORKING,
  // mas para o usuário a UI deve refletir "Agente pausado".
  let statusLabel = STATUS_LABEL[statusKey] || (session ? statusKey : 'Desconectado');
  let statusVariant = STATUS_VARIANT_MAP[statusKey] || 'neutral';
  if (agentPaused) {
    statusLabel = 'Agente pausado';
    statusVariant = 'warning';
  }

  return {
    isConnected,
    isLoading,
    error,
    statusLabel,
    statusVariant,
    summary: phone ? `Sessão: ${phone}` : '',
    refresh: fetch,
    raw: session,
    phone,
    agentPaused,
  };
}
